import React from 'react';
import { Accent, SectionHeading } from './SectionHeading';
import { bonusDetails } from '../../data/content';
export function BonusesSection() {
  return <section aria-labelledby="bonus-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-70" data-mp="1keqgtiv6l8au">
      <div className="mx-auto max-w-5xl" data-id="element-71" data-mp="16j4ujjgc12m4">
        <SectionHeading id="bonus-heading" eyebrow="Included With Your Purchase" title={<>
              And You Get <Accent data-id="element-73" data-mp="wp6076mi2n4q">5 Additional</Accent> Nail Educator Resources.
            </>} data-id="element-72" data-mp="1bjivyinfheb6" />

        <ol className="mt-14 grid gap-6 md:grid-cols-2" role="list" data-id="element-74" data-mp="11k1rg4jwx6gs">
          {bonusDetails.map((bonus, index) => <li key={bonus.number} className={`flex h-full flex-col overflow-hidden rounded-[20px] border border-brand-charcoal/10 bg-white shadow-[0_24px_50px_-36px_rgba(90,70,40,0.45)] ${index === bonusDetails.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-75" data-mp="slg9aaicrtgj" data-mpi={index}>
              <div className="px-6 py-3" style={{
            backgroundColor: bonus.accent
          }} data-id="element-76" data-mp="1k7294l42qm51">
                <p className="font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-charcoal/75" data-id="element-77" data-mp="1g6iebo6z3um2">
                  {bonus.number}
                </p>
              </div>
              <div className="flex flex-1 flex-col px-6 py-7 sm:px-8" data-id="element-78" data-mp="1oyu0uyyyuxwr">
                <h3 className="font-display text-[1.45rem] font-bold leading-snug text-brand-charcoal" data-id="element-79" data-mp="1p0n92ip89q6v">{bonus.title}</h3>
                <p className="mt-2.5 text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-80" data-mp="x7e6gir646vz">{bonus.description}</p>
                {bonus.flow && <p className="mt-auto pt-5 font-body text-[11px] font-semibold uppercase tracking-[0.14em] text-brand-gold" data-id="element-81" data-mp="1b7yp9ex322ph">
                    {bonus.flow}
                  </p>}
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}